import { useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils'; 
const STORAGE_KEY = 'forced_logout_session_start';
export const useForcedLogout = (settings) => {
  useEffect(() => {
    if (!settings || !settings.forcedLogoutOn) return;
    const limitDays = parseInt(settings.forcedLogoutDays, 10) || 30;
    const LIMIT_MS = limitDays * 24 * 60 * 60 * 1000; 
    const checkTimeout = async () => {
      const startTimeStr = localStorage.getItem(STORAGE_KEY);
      if (!startTimeStr) {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
        return;
      }
      const startTime = parseInt(startTimeStr, 10);
      const currentTime = Date.now();
      if (currentTime - startTime > LIMIT_MS) {
        console.warn(`[Forced Logout] Session limit of ${limitDays} days reached. Logging out...`);
        
        try {
          localStorage.removeItem(STORAGE_KEY);
          await signOut(); 
          window.location.href = "/login"; 
        } catch (error) {
          console.error("Forced logout failed:", error);
        }
      }
    };
    const hubListener = Hub.listen('auth', ({ payload }) => {
      const { event } = payload;
      if (event === 'signedIn') {
        console.log('[Forced Logout] User signed in. Starting session timer.');
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      } 
      else if (event === 'signedOut') {
        localStorage.removeItem(STORAGE_KEY);
      }
    });
    checkTimeout();
    const intervalId = setInterval(checkTimeout, 60 * 1000); 
    return () => {
      clearInterval(intervalId);
      hubListener(); 
    };
  }, [settings]);
};